import './_collection-delivery-selection-date.scss';

export default () => {};
